const ButtonAction = ({ item, type, onClick }) => {
    return (
        <button
            key={item.id}
            className={`${type === item.value ? " bg-yellowgray text-white " : " bg-white text-black "}${" text-sm border shadow-sm rounded-xl p-3 px-4 py-2 capitalize "}`}
            onClick={onClick}
        >
            {item.label}
        </button>
    )
}

export default ButtonAction;